import type { PageProps } from 'gatsby';
import React from 'react';

import { FeatureGuard } from '@components/Guards';

import ImportJobList from '@views/Admin/NewAccount/ImportJobList/ImportJobList';

export default function ImportHistoryPage({ params }: PageProps) {
  return (
    <FeatureGuard feature="UserListBulkImports">
      <ImportJobList {...params} />
    </FeatureGuard>
  );
}
